import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../errorManage';
import messages from '../messages';
import { saveDoc } from '../gestorDocumental/actions';
import gestorDocumentalServices from '../gestorDocumental/gestorDocumental.services';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getEducation = (data, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EDUCATION,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
     
    const resp = await client.get(iType === 1 ? '/api/app/Formal_Educacion/' : `/api/app/Funcional_Educacion/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_EDUCATION,
      payload: {
        education: resp.data.data,
        educationLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EDUCATION,
      payload: false
    });
  }
}

export const saveEducation = (data, iType, dataGD, exist, setShowModal, setValidFechaDoc, resetForm) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_EDUCATION,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post(iType === 1 ? '/api/app/Formal_Educacion/' : '/api/app/Funcional_Educacion/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    dataGD.append("id_registro", parseInt(resp.data.id));
    const { education, educationLength } = getState().education;
    if(exist){
      const respGD = await gestorDocumentalServices.saveDocument(dataGD);
      const respPUTRel = await client.put(iType === 1 ? `/api/app/Formal_Educacion/${resp.data.id}/` : `/api/app/Funcional_Educacion/${resp.data.id}/`, {
        ...data,
        archivos_gestor: respGD.data.resultado.id
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`
        }});
      const aEducation = [...education, respPUTRel.data];
      dispatch({
        type: actions.GET_EDUCATION,
        payload: {
          education: aEducation,
          educationLength: educationLength + 1
        }
      });
    }else{
      const aEducation = [...education, resp.data];
      dispatch({
        type: actions.GET_EDUCATION,
        payload: {
          education: aEducation,
          educationLength: educationLength + 1
        }
      });
    }
    toastr.success(messages.successMessage);
    setShowModal(false);
    setValidFechaDoc(false);
    resetForm.reset();
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_EDUCATION,
      payload: false
    });
  }
}

export const editEducation = (data, id, index, iType, dataGD, arGD, exist, setShowModal, setValidFechaDoc) => async (dispatch, getState) => {
  try {
    debugger;
    dispatch({
      type: actions.SAVE_LOADER_EDUCATION,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const { education, educationLength } = getState().education;
    if(exist){
      dataGD.append("id_registro", parseInt(id));
      let respGD;
      if(arGD){
        respGD = await gestorDocumentalServices.editDocument(arGD, dataGD);
      }else{
        respGD = await gestorDocumentalServices.saveDocument(dataGD);
      }
      const resp = await client.put(iType === 1 ? `/api/app/Formal_Educacion/${id}/` : `/api/app/Funcional_Educacion/${id}/`, {
        ...data,
        archivos_gestor: arGD ? respGD.data.id : respGD.data.resultado.id
      }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
      education[index] = resp.data;
    }else{
      const resp = await client.put(iType === 1 ? `/api/app/Formal_Educacion/${id}/` : `/api/app/Funcional_Educacion/${id}/`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
      education[index] = resp.data;
    }
    dispatch({
      type: actions.GET_EDUCATION,
      payload: {
        education: education,
        educationLength: educationLength
      }
    });
    toastr.success(messages.successMessage);
    setShowModal(false);
    setValidFechaDoc(false);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_EDUCATION,
      payload: false
    });
  }
}

export const deleteEducation = (id, index, iType) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_EDUCATION,
      payload: true
    });
     
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(iType === 1 ? `/api/app/Formal_Educacion/${id}/` : `/api/app/Funcional_Educacion/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { education, educationLength } = getState().education;
    education.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_EDUCATION,
      payload: {
        education: education,
        educationLength: educationLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_EDUCATION,
      payload: false
    });
  }
}
